// v2.18 — les adresses exactes que les pages demandent, pour les précharger avant le clic.
import { format, startOfWeek, endOfWeek, startOfMonth, endOfMonth, addDays } from 'date-fns';

// Planning : le mois affiché, en semaines complètes
export const planningRange = (weekStart = startOfWeek(new Date(), { weekStartsOn: 1 })) => {
  const month = startOfMonth(addDays(weekStart, 6));
  return {
    start: format(startOfWeek(month, { weekStartsOn: 1 }), "yyyy-MM-dd'T'00:00:00"),
    end: format(endOfWeek(endOfMonth(month), { weekStartsOn: 1 }), "yyyy-MM-dd'T'23:59:59"),
  };
};

// Collectifs : les cours choisis pour le tableau des revenus (par défaut : les actifs)
export const pivotIds = (courses) => {
  try {
    const saved = JSON.parse(localStorage.getItem('pivot_selected_ids') || 'null');
    const valid = (saved || []).filter(id => courses.some(c => c.id === id));
    if (valid.length > 0) return valid;
  } catch {}
  return courses.filter(c => c.is_active !== false).map(c => c.id);
};
export const pivotUrl = (ids) => `/group-courses/revenue-summary?course_ids=${[...ids].sort().join(',')}`;

export const prefetchPaths = (courses) => {
  const { start, end } = planningRange();
  const q = `start=${start}&end=${end}`;
  const ids = pivotIds(courses);
  return [`/planning/data?${q}`, `/gtasks/events?${q}`, `/gcal/events?${q}`, "/gcal/calendars", ...(ids.length ? [pivotUrl(ids)] : [])];
};
